const ORDER_TRADE_IN_RESULTS_LOADER = (() => {
  const ORDER_LOOKUP_PATHNAME = `${Shopify.routes.root}pages/order-lookup`;

  const GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY = `
    getRefreshedOrderAndTradeinLookupToken(token: $token) {
      refreshedToken
      expiresAt
    }
  `;

  // Example `error.message` values this regexp is intended to match:
  //   jwt expired
  //   jwt malformed
  //   invalid signature
  const TOKEN_ERROR = /\b(jwt|signature)\b/i;

  /**
   * Does the provided GraphQL error object represent a token error? Token errors are ones that
   * can likely be fixed by re-authenticating into the Order Lookup Tool.
   * @param {*} error The GraphQL error object.
   * @returns {boolean} `true` if this error looks like a token error, otherwise `false`
   */
  // TODO: Less brittle error type detection
  const isTokenError = error => TOKEN_ERROR.test(error.message);

  const navigateToOrderLookup = () => {
    window.location.pathname = ORDER_LOOKUP_PATHNAME;
  };

  const loadResults = async (queryName, doFetchResults) => {
    const { getActiveToken, saveTokenFromQueryString } = ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS;
    saveTokenFromQueryString();
    const token = getActiveToken();
    if (!token) {
      navigateToOrderLookup();
    }

    try {
      const response = await doFetchResults({
        token,
        partnerUuid: localStorage.getItem('partnerUuid'),
      });
      if (!response.ok) {
        throw new Error(`Failed request ${queryName} with status code ${response.status}`);
      }

      const responseJson = await response.json();
      if (responseJson.errors) {
        if (responseJson.errors.some(isTokenError)) {
          // A token error means auto-navigate back to the order-lookup page
          ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS.clearSavedToken();
          navigateToOrderLookup();
        }
        throw new Error(
          `Request ${queryName} returned GraphQL errors: ${JSON.stringify(responseJson.errors)}`,
        );
      }

      const { getRefreshedOrderAndTradeinLookupToken, ...rest } = responseJson.data;
      if (getRefreshedOrderAndTradeinLookupToken) {
        const { refreshedToken, expiresAt } = getRefreshedOrderAndTradeinLookupToken;
        ORDER_TRADE_IN_LOOKUP_TOKEN_UTILS.saveRefreshedToken(refreshedToken, expiresAt);
      }

      return rest;
    } catch (err) {
      console.error(err);
      return {};
    }
  };

  return {
    GET_REFRESHED_ORDER_AND_TRADEIN_LOOKUP_TOKEN_QUERY,
    loadResults,
  };
})();
